import { Link } from "react-router";
import { SALES_DEFINITIONS } from "./salesDefinitions.ts";
import { StripeOrderStatus } from "../../Stripe/StripeOrderDTO.ts";
import { SalesGateway } from "./SaleRecord.ts";
import { InstallmentsHealth } from "./salesBreakdowns.ts";
import { formatCount, formatEuros, formatPercent } from "./salesFormat.ts";
import { ordersListPathFor } from "./ordersListLinks.ts";
import {
  EmptyStatistics,
  LoadingBlock,
  Stat,
  StatisticsCard,
} from "./StatisticsCard.tsx";

const DELINQUENT_ORDERS_PATH = ordersListPathFor({
  gateway: SalesGateway.Stripe,
  statuses: [StripeOrderStatus.InstallmentDelinquent],
});

export function InstallmentsHealthCard({
  health,
  isLoading,
}: {
  health: InstallmentsHealth;
  isLoading: boolean;
}) {
  return (
    <StatisticsCard
      title="Rate Stripe ad oggi"
      info={SALES_DEFINITIONS.installmentsHealth}
      description="Piani a rate ancora in corso, con i filtri attivi"
    >
      {isLoading ? (
        <LoadingBlock className="h-32 w-full" />
      ) : health.runningPlanCount === 0 && health.cancelledPlanCount === 0 ? (
        <EmptyStatistics>Nessun piano a rate in corso</EmptyStatistics>
      ) : (
        <div className="flex flex-col gap-4">
          <div className="grid grid-cols-2 gap-4">
            <Stat
              label="Piani in corso"
              value={formatCount(health.runningPlanCount)}
            />
            <Stat
              label="Piani insoluti"
              value={formatCount(health.delinquentPlanCount)}
            >
              <span className="text-xs text-gray-500">
                {formatPercent(health.delinquencyRate)} dei piani in corso
              </span>
              {health.delinquentPlanCount > 0 && (
                <Link
                  to={DELINQUENT_ORDERS_PATH}
                  className="text-xs text-blue-600 hover:underline"
                >
                  Vedi gli ordini insoluti
                </Link>
              )}
            </Stat>
            <Stat
              label="Rate insolute"
              value={formatEuros(health.overdueInCents)}
            />
            <Stat
              label="Rate da incassare"
              value={formatEuros(health.upcomingInCents)}
            />
          </div>
          {health.cancelledPlanCount > 0 && (
            <p className="text-xs text-gray-500">
              Sugli ordini del periodo,{" "}
              <span className="font-medium text-gray-700">
                {formatCount(health.cancelledPlanCount)}{" "}
                {health.cancelledPlanCount === 1
                  ? "piano è stato annullato"
                  : "piani sono stati annullati"}
              </span>{" "}
              lasciando {formatEuros(health.unpaidOnCancelledPlansInCents)} di
              rate non pagate.
            </p>
          )}
        </div>
      )}
    </StatisticsCard>
  );
}
